export { default } from './SplitHero';
